module.exports = __webpack_public_path__ + "static/media/edit-icon.bd9140c2.svg";